import { Filters } from '@livecontrol/scheduler/components';
import React from 'react';
// import { Dropdown } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import shallow from 'zustand/shallow';
import { useEventsStore } from '../../store';

interface Props {
  className?: string;
  isOldVersion?: boolean;
}

export const DateRange = ({ className, isOldVersion = false }: Props): React.ReactElement => {
  const { dateRange, setDateRange } = useEventsStore((v) => ({
    dateRange: v.filters.dateRange,
    setDateRange: v.setDateRange
  }), shallow);

  return isOldVersion ?
    <Filters.PeriodOld
      value={dateRange}
      onChange={setDateRange}
      className={className}
      showFormatOnMobile
      variant={dateRange?.min && dateRange.max ? 'secondary' : 'outline-lightgrey'}
    />
    :
    <Filters.Period
      value={dateRange}
      onChange={setDateRange}
      className={className}
      showFormatOnMobile
      variant={dateRange?.min && dateRange.max ? 'secondary' : 'outline-lightgrey'}
    />
  ;
};
